import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Channels, Graphics } from "constant";

function ColorFromStatus(status) {
  status = status.toLowerCase();
  if (status === "online") {
    return "onlineStatus";
  } else if (status === "offline") {
    return "offlineStatus";
  } else if (status === "idle") {
    return "idleStatus";
  }
}

export default class Avatar extends Component {
  static propTypes = {
    image: PropTypes.string,
    channel: PropTypes.string,
    status: PropTypes.string,
    isSmall: PropTypes.bool,
    isCustomChannel: PropTypes.bool
  };
  static defaultProps = {
    isSmall: false
  };

  render() {
    const {
      image,
      channel,
      isSmall,
      status,
      className,
      isCustomChannel
    } = this.props;
    const channelData = channel && this.getChannel(channel);
    return (
      <Wrapper isSmall={isSmall} image={image} className={className}>
        {channel &&
          channelData && (
            <Channel
              image={Graphics[channelData.icon]}
              isCustomChannel={isCustomChannel}
            />
          )}
        {status && <Indicator color={ColorFromStatus(status)} />}
      </Wrapper>
    );
  }

  getChannel = channel => {
    for (const ch of Channels) {
      if (ch.name === channel) {
        return ch;
      }
    }
  };
}

const Wrapper = styled.div`
  flex: none;
  display: inline-flex;
  vertical-align: top;
  align-items: flex-end;
  justify-content: flex-end;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: #ccc;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${props =>
    props.image &&
    css`
      background-image: url(${props.image});
    `};
  ${props =>
    props.isSmall &&
    css`
      width: 26px;
      height: 26px;
      border-radius: 100%;
    `};
`;
const Channel = styled.div`
  margin-right: -10px;
  margin-bottom: -2px;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${props =>
    props.isCustomChannel &&
    css`
      width: 40px;
      height: 40px;
    `};
  ${props =>
    props.image &&
    css`
      background-image: url(${props.image});
    `};
`;
const Indicator = styled.div`
  margin-right: -2px;
  margin-bottom: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  ${props =>
    props.color &&
    css`
      background-color: ${props.theme[props.color]};
    `};
`;



// WEBPACK FOOTER //
// ./src/module-common/Avatar.js